import { render, staticRenderFns } from "./PendingAppointment.vue?vue&type=template&id=2a86d700"
import script from "./PendingAppointment.vue?vue&type=script&lang=js"
export * from "./PendingAppointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports